import {styled} from '@mui/material';
import clsx from 'clsx';
import {ComponentPropsWithRef, FC} from 'react';
import {navCssClassNames} from './navCssClassNames';

const BaseElement: FC<ComponentPropsWithRef<'li'>> = ({
    className, ...props
}) => (
    <li
        className={clsx(className, navCssClassNames.item)}
        {...props}
    />
);

export const NavItem = styled(BaseElement)`
    display: block;
    margin: 0;
    padding: 0;
`;
